<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 2.43262L13.5 13.4326" stroke="#FF4A4A" stroke-width="1.2"/>
<path d="M16 8.18457C16 12.6028 12.4183 16.1846 8 16.1846C3.58172 16.1846 0 12.6028 0 8.18457C0 3.76629 3.58172 0.18457 8 0.18457C12.4183 0.18457 16 3.76629 16 8.18457Z" fill="#858585"/>
<path d="M7.99927 4.68359V8.18359L10.9993 11.1836" stroke="white" stroke-width="1.2"/>
</svg>
